import React, { Component } from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import LanguageSelector from '../i18/languageSelector'
import InputPasswordField from '../common/inputpassword'
class PasswordReset extends React.Component {

  state = {
    password: '',
    passwordConfirm: '',
    anchorEl: null,
    error: false,
    weak: false,
    valid: true,
    match: true,
  }

  handleChange = (name) => event => {
    this.setState({
      error: false,
      weak: false,
      match: true,
      valid: true,
      [name]: event.target.value,
    });
  };

  handleSubmit() {
    const { password, passwordConfirm } = this.state

    let strong = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})")

    let valid = strong.test(password)

    if (!valid) {
      this.setState({ error: true, valid: false, weak: true })
      return
    }

    if (password !== passwordConfirm) {
      this.setState({ error: true, valid: false, match: false })
      return
    }

    this.props.resetPassword({
      password: this.state.password,
      email: this.props.email,
      token: this.props.token
    })
  }

  handleLanguageChange = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleLanguageChangeClose = (language) => {
    this.setState({ anchorEl: null })

    if (typeof (language) === 'string')
      this.props.setLanguage(language)
  }

  handleEnterKeyPress = () => (event) => {
    if (event) {
      let pressedKeycode = event.keyCode || event.charCode
      if (pressedKeycode === 13) {
        this.handleSubmit()
      }
    }
  }

  render() {
    const {
      classes,
      translate,
      languages,
      activeLanguage,
      token,
      email,
      setLanguage,
      isValid
    } = this.props
    if (!isValid) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>

            <Grid container spacing={24}>
              <Grid item xs={24}>
                <Typography type="title">
                  {translate("password_set_invalid_token")}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </div>
      )
    }

    return (
      <div className={classes.root}>
        <form noValidate autoComplete="off">
          <Paper className={classes.paper}>

            <Grid container spacing={24}>
              <Grid item xs={10}>
                <Typography type="headline">
                  {translate('reset_welcome')}
                </Typography>
                {
                  (this.state.valid)
                    ? <Valid translate={translate} />
                    : <Invalid
                      translate={translate}
                      weak={this.state.weak}
                      match={this.state.match}
                    />
                }
              </Grid>
              <Grid item xs={2}>
                <LanguageSelector
                  handleLanguageChange={this.handleLanguageChange}
                  handleLanguageChangeClose={this.handleLanguageChangeClose}
                  anchorEl={this.state.anchorEl}
                  activeLanguage={activeLanguage}
                  languages={languages}
                />
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <InputPasswordField
                  classes={classes}
                  error={this.state.error}
                  id="password"
                  label={translate('reset_password')}
                  onChange={this.handleChange('password')}
                  value={this.state.password}
                  helperText={translate('password_helper_text')}
                  />
              </Grid>
              <Grid item xs={12}>
                <InputPasswordField
                  classes={classes}
                  error={this.state.error}
                  id="passwordConfirm"
                  label={translate('reset_password_confirm')}
                  onChange={this.handleChange('passwordConfirm')}
                  onKeyPress={this.handleEnterKeyPress()}
                  value={this.state.passwordConfirm}
                  helperText={translate('password_helper_text')}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  color="primary"
                  raised
                  fullWidth
                  onClick={() => this.handleSubmit()}
                >
                  {translate('reset_reset')}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </div>
    )
  }

}

const Valid = ({ translate }) => (
  <Typography color="primary" gutterBottom>
    {translate('reset_message')}
  </Typography>
)

const Invalid = ({ translate, weak, match }) => {
  return (
    <Typography color="error" gutterBottom>
      {
        (weak) ? (
          translate('reset_weak')
        ) : (!match) ? (
          translate('reset_match')
        ) : (
              translate('reset_error')
            )
      }
    </Typography>
  )
}

export default withStyles(styles)(PasswordReset)
